// Submit a form to the backend which persists it and emails the team.
// Returns { ok, id, emailStatus, emailError }.

const BACKEND = process.env.REACT_APP_BACKEND_URL;

export async function submitForm({ formType, fields, contactEmail = null, contactName = null }) {
  const res = await fetch(`${BACKEND}/api/forms/submit`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      form_type: formType,
      fields,
      contact_email: contactEmail,
      contact_name: contactName,
    }),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(data.detail || `Request failed (${res.status})`);
  }
  return {
    ok: true,
    id: data.id,
    emailStatus: data.status,          // "ok" (sent) or "queued" (persisted, email failed)
    emailError: data.email_error || null,
  };
}
